import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidatorFn } from "@angular/forms";

import { Category } from "../../../../models/survey-engine/category";
import { CategoricalAnswer, CategoricalAnswerCollection, ICategoricalAnswer, ICategoricalAnswerCollection } from "../../../../models/survey-engine/core/categorical-answer";
import { MultiImageAnswer } from "../../../../models/survey-engine/multi-image-answer";
import { CategoricalQuestionBaseComponent } from "../core/categorical-question-base.component";

import "../../../../extensions/string-extensions";
import { Message } from "../../../../localization/message";
import { AnswerType } from "../../../../models/survey-engine/core/answer-type.enum";
import { MultiImageQuestion, IMultiImageQuestionData } from "../../../../models/survey-engine/multi-image-question";

@Component({
  standalone: false,
  selector: "app-multi-image-question",
  templateUrl: "./multi-image-question.component.html",
  styleUrls: ["./multi-image-question.component.scss"]
})
export class MultiImageQuestionComponent extends CategoricalQuestionBaseComponent implements OnInit, OnDestroy {
  protected setQuestionAnswer(value: any) {
    const self = this;
    self.__questionAnswer = new MultiImageAnswer();
    value = value || {};
    const answer: ICategoricalAnswerCollection = new CategoricalAnswerCollection();
    Object.keys(value).forEach(code => {
      answer.add(
        new CategoricalAnswer({
          code: Number(code),
          value: "",
          checked: value[code],
          categoryId: self.getCategory(code).id
        })
      );
    });
    (self.__questionAnswer as MultiImageAnswer).answerType = AnswerType.MultiPunchImage;
    (self.__questionAnswer as MultiImageAnswer).values = answer; //self.__answers;
  }
  get minAnswersErrorMessage(): string {
    return this.__minAnswersErrorMessage;
  }

  get maxAnswersErrorMessage(): string {
    return this.__maxAnswersErrorMessage;
  }

  get categories(): Array<Category> {
    const categories: Array<Category> = [];
    (this.question as MultiImageQuestion).categories.$values.forEach(c => {
      categories.push(c as Category);
    });
    return categories;
  }

  constructor() {
    super();
  }

  inputData: Array<IMultiImageQuestionData> = [];
  ngOnInit() {
    super.ngOnInit();
    const self = this;

    if (self.question.response as MultiImageAnswer) {
      self.__answers = new CategoricalAnswerCollection((self.question.response as MultiImageAnswer).values);
    } else {
      self.categories.forEach((category: Category) => {
        self.__answers.$values.push(
          new CategoricalAnswer({
            categoryId: category.id,
            code: category.code
          })
        );
      });
    }

    const validators = [];
    if ((self.question as MultiImageQuestion).validators.required) {
      validators.push(CustomMultiValidators.required);
    }

    Object.keys((self.question as MultiImageQuestion).validators).forEach(validator => {
      if (validator !== "required" && (self.question as MultiImageQuestion).validators[validator] && CustomMultiValidators[validator]) {
        validators.push(CustomMultiValidators[validator].apply(undefined, [(self.question as MultiImageQuestion).validators[validator]]));
      }
    });

    self.ctrl.setValidators(validators);

    self.categories.forEach((category: Category) => {
      const answer = self.getAnswerByCategoryId(category.id);
      const ctrl: FormControl = self.getCtrl(category.code);

      ctrl.valueChanges.subscribe((value: boolean) => {
        answer.checked = value;
        if (!category.isExclusive && value) {
          self.categories
            .filter((c: Category) => c.isExclusive)
            .forEach((c: Category) => {
              const _ctrl: FormControl = self.getCtrl(c.code);
              const _answer = self.getAnswer(c.code);
              _answer.checked = false;
              _answer.value = "";
              _ctrl.setValue(false);
            });
        }
        if (category.isExclusive && value) {
          self.categories
            .filter((c: Category) => !c.isExclusive)
            .forEach((c: Category) => {
              let _ctrl: FormControl = self.getCtrl(c.code);
              const _answer = self.getAnswer(c.code);
              _answer.checked = false;
              _answer.value = "";
              _ctrl.setValue(false);
              _ctrl = self.otherCtrls[c.code];
              if (_ctrl) {
                _ctrl.setValue("");
              }
            });
        }
      });
      if (answer.checked) {
        ctrl.setValue(answer.checked);
      }

      if (category.isOther && self.otherCtrls) {
        const otherCtrl: FormControl = self.otherCtrls[category.code];
        otherCtrl.valueChanges.subscribe((value: string) => {
          ctrl.setValue(!!value);
          answer.value = value;
        });
        if (answer.value) {
          otherCtrl.setValue(answer.value);
        }
      }
    });


    (self.question as MultiImageQuestion).categories.$values.forEach(c => {
      self.inputData.push({
        imageName: c.rightText,
        imagePath: c.leftText,
        imageSelected: false,
        questionId: c.questionId,
        categoryId: c.id,
        code: c.code
      });
    });
    self.__minAnswersErrorMessage = String.format(Message.MinAnswersExceededMessage,  (this.question as MultiImageQuestion).validators.minAnswers);
    self.__maxAnswersErrorMessage = String.format(Message.MaxAnswersExceededMessage,  (this.question as MultiImageQuestion).validators.maxAnswers);
    self.triggerQuestionLoaded();
  }

  get hideCheckBox(): boolean {
    try {
      let radioButtonData: any = document.getElementsByClassName("multiImage");
      if (!!radioButtonData) {
        for (var i = 0; i < radioButtonData.length; i++) {
          var imagefilterdata = radioButtonData[i];
          var multiImageData: any = imagefilterdata;//.getElementsByClassName("singleImage");
          if (!!multiImageData) {
            for (var j = 0; j < multiImageData.getElementsByClassName("mat-checkbox-inner-container").length; j++) {
              var gg: any = multiImageData.getElementsByClassName("mat-checkbox-inner-container")[j];
              gg.style.display = 'none'
            }
          }
        }
      }

    } catch (ex) {

    }
    return false;
  }
  getCtrl(code: number | string): FormControl {
    const self = this;
    try {
      let radioButtonData: any = document.getElementsByClassName("multiImage");
      if (!!radioButtonData) {
        for (var i = 0; i < radioButtonData.length; i++) {
          var imagefilterdata = radioButtonData[i];
          var multiImageData: any = imagefilterdata;//.getElementsByClassName("singleImage");
          if (!!multiImageData) {
            for (var j = 0; j < multiImageData.getElementsByClassName("mat-checkbox-inner-container").length; j++) {
              var gg: any = multiImageData.getElementsByClassName("mat-checkbox-inner-container")[j];
              gg.style.display = 'none'
            }
          }
        }
      }

    } catch (ex) {

    }
    code = code.toString();
    const fg = self.ctrl as FormGroup;
    if (fg.contains(code)) {
      return fg.get(code) as FormControl;
    }
    return new FormControl();
  }

  getAnswer(code: string | number): ICategoricalAnswer {
    const results = this.__answers.$values.filter(item => item.code === code);
    const _answer: ICategoricalAnswer = results.length ? results[0] : {};
    return _answer;
  }

  getAnswerByCategoryId(id: number): ICategoricalAnswer {
    const results = this.__answers.$values.filter(item => item.categoryId === id);
    const _answer: ICategoricalAnswer = results.length ? results[0] : {};
    return _answer;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  public fixImageSelectedId(category: any) {
    const self = this;
    category.imageSelected = !category.imageSelected;
  }

  public imageId = 0;

  protected __answers: CategoricalAnswerCollection = new CategoricalAnswerCollection();

  private __minAnswersErrorMessage: string;
  private __maxAnswersErrorMessage: string;
}

class CustomMultiValidators {
  static required(fg: FormGroup): { [key: string]: boolean } | null {
    const valid = Object.keys(fg.controls).some(k => fg.get(k).value);
    return valid
      ? null
      : {
        required: true
      };
  }

  static minAnswers(nr: number): ValidatorFn {
    return (fg: FormGroup): { [key: string]: boolean } | null => {
      const count = Object.keys(fg.controls).filter(k => fg.get(k).value).length;
      return count >= nr
        ? null
        : {
          minAnswers: true
        };
    };
  }

  static maxAnswers(nr: number): ValidatorFn {
    return (fg: FormGroup): { [key: string]: boolean } | null => {
      const count = Object.keys(fg.controls).filter(k => fg.get(k).value).length;
      return count <= nr
        ? null
        : {
          maxAnswers: true
        };
    };
  }
}
